module.exports = __webpack_public_path__ + "img/bigstock-Big-Blue-Ocean-Wave-Background-357723107.27517d5e.png";